import { render, staticRenderFns } from "./open_cases_pie_chart.vue?vue&type=template&id=74d7f10b&scoped=true&"
import script from "./open_cases_pie_chart.vue?vue&type=script&lang=js&"
export * from "./open_cases_pie_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d7f10b",
  null
  
)

export default component.exports